import { Rating, TextArea } from "../common/Forms";
import { CheckboxInputGroup, RadioInputGroup } from "./SurveyComponents";

const SurveyView = (props) => {
  const { title, contents, id, questions, options } = props;
  return (
    <>
      <div className="container mx-auto">
        <div className="bg-cyan-500 px-6 py-4 md:px-10 md:py-8">
          <h1 className="break-keep md:text-5xl text-3xl leading-tight text-white font-bold">
            {title}
          </h1>
          <h3 className="mt-6 break-keep text-white">
            {contents.map((v, i) => (
              <p key={`content_${id}_${i}`}>{v}</p>
            ))}
          </h3>
        </div>
        <div className="border-t border-zinc-200 bg-white md:p-8 shadow">
          <ol className="my-4 ml-6 sm:ml-10 list-decimal">
            {questions.map(({ content, required, type }, i) => (
              <li className="mb-8 font-semibold text-black" key={`q_${i}`}>
                {content &&
                  content.map((v, j) => (
                    <div key={`q_sentence_${j}`}>
                      <span className={j > 0 ? "block" : ""}>{v}</span>
                      {j === 0 && required && (
                        <span className="ordinal text-red-600"> *</span>
                      )}
                    </div>
                  ))}

                <div className="mt-4 ml-4 space-y-4">
                  {(type === "text" || type === "textarea") && (
                    <TextArea
                      name={`q_${i}_options`}
                      placeholder={
                        options[i][0].content || "답변을 입력하세요."
                      }
                      className="w-3/5 p-1 max-md:w-1/2 max-sm:mr-12 max-sm:w-full"
                    />
                  )}
                  {type === "rating" && (
                    <Rating
                      {...{
                        length: 10,
                        id: `${type}-${i}`,
                      }}
                    />
                  )}
                  {type === "radio" && (
                    <RadioInputGroup
                      {...{
                        option: options[i],
                        index: i,
                      }}
                    />
                  )}
                  {type === "checkbox" && (
                    <CheckboxInputGroup
                      {...{
                        option: options[i],
                        index: i,
                      }}
                    />
                  )}
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </>
  );
};

export default SurveyView;
